import { CopyOutlined } from "@ant-design/icons"
import React from "react"
import botStore from "../../stores/botStore"
import { API_URL } from "../../services/constants"

const DynamicBannerLink = () => {
    const bot = botStore((state) => state.bot)

    return (
        <div className="max-w-6xl mx-auto">
            <h1 className="flex justify-end text-base"> :لینک تغییر اتومات بنر</h1>
            <div className="bg-slate-800 w-full mt-2 rounded-lg flex items-center justify-between">
                <div className="py-2 px-5">{`${API_URL}/banner/${bot.templateName}`}</div>
            </div>
        </div>
    )
}

export default DynamicBannerLink
